module.exports = __webpack_public_path__ + "img/Monte_Kope_33.fe5af949.jpg";